import Slider from "react-slick";
import { useRef } from "react";
import { getImages } from "../const";
import { Link } from "react-router-dom";
import ReviewPreview from "./ReviewPreview";

const reviewsList = [
  {
    name: "Keith Smith (Mayorofmycity)",
    date: '2 months ago',
    content:
      "I had an excellent experience working with Matt Yates at McLaren Orlando. His customer service is truly exceptional right from the start, I felt at ease making such a large purchase for the first time. Matt guided me seamlessly through the entire process, answering every question I had with patience and professionalism. His dedication and expertise made what could have been a stressful experience completely smooth and enjoyable. I highly recommend Matt to anyone looking to get into a McLaren; you’ll be in great hands! Now I'm riding in a new McLaren 😎 🙌🏾",
  },
  {
    name: "Christopher Darling",
    date: '2 months ago',
    content:
      "My sales person, Matt Yates did a fantastic job working with me via phone and text for over a week. Patiently answered my questions and shared info on multiple versions of the Artura to help me make the best decision for me. He met with me outside regular hours and it ended up a seamless deal.",
  },
  {
    name: "Andy Ramirez",
    date: 'a month ago',
    content:
      "Matt was the best to work with and everyone from the front office to the back was extremely helpful throughout the whole process. They were patient and understanding. This was my first McLaren and I’ll definitely come back for my 2nd.",
  },

  {
    name: "Mark Zaremskas",
    date: 'a month ago',
    content:
      "First class dealership!! I have had three McLarens now (all bought second hand)...And none of them purchased from this dealership. I was unlucky as at the time they did not have exactly what I wanted (as I was looking for something very specific). My point here...Is that I was treated as if I had purchased multiple cars from McLaren Orlando! I continue to take my cars there for servicing...I am always treated fairly and feel like I am a valued customer! And the best part is the team of experts (George, Ryder and techs) have always handed my car(s) back in the condition expected with no issues. The new dealership is amazing...A",
  },
  {
    name: "Shaun Spry",
    date: '2 weeks ago',
    content:
      "Just closed a deal with Matt Yates. Excellent experience from initial walk-in to drive-out, which in my case took longer than usual. I knew very little about the brand, so I had lots of annoying questions. Matt was endlessly patient and never pushed. Zero pressure is how car buying should be! I also spent quality time with Joe. He runs a dealership focused on his clients, is a great guy, and has lots of fun stories and valuable insight. Highly recommend McLaren of Orlando!",
  },

  {
    name: "Hayden Mitchell",
    date: 'Edited 6 months ago',
    content:
      "Yesterday I took delivery of my 600LT (11/26/24) and wanted to share my experience working with this dealer. Purchasing a vehicle out of state can be stressful but Matt was great and helped answer questions and concerns about the car. The 600LT has been an absolute blast and I want to thank Matt and the team over at Mclaren of Orlando for making it happen.",
  },
  {
    name: "Jon Larsen",
    date: '5 months ago',
    content:
      "I had an amazing experience at McLaren Orlando leasing my 25 Artura Spyder. The car is amazing and I’m looking forward to the next few years of ownership . From the beginning, Matt Yates was instrumental in helping me through the entire process from the initial test drive to receiving the car. He was extremely helpful in making my decision to get the car easy and also with any questions I had after. He also helped me to get the most for my trade in on my 600LT. Thanks again to Matt Yates and all of the staff at McLaren Orlando!",
  },
];

const CustomerReviews = () => {
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerPadding: "20px",
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className='customer-reviews-wrap'>
        <div className='container'>
          <div className='d-md-flex align-items-center justify-content-between reviews-heading mb-4'>
            <h2 className='lg-title text-gray fw-300 text-uppercase mb-3 mb-md-0 wow reveal fadeInUp'>Customer Reviews</h2>

            <a href="https://share.google/ZbO83xyagjz5QGhYE" target="_blank" className="d-block">
              <div className='d-flex align-items-center wow reveal fadeInUp'>
                <img className='g-icon me-md-4 me-3' src={getImages("icon-google-user.png")} alt="quote" />
                <div className='lg-title font-2em fw-700 wow reveal fadeInUp helveticaneue me-md-4 me-3 rating-count'>4.9</div>
                <div>
                  <div className='xs-title font-12 text-uppercase fw-500 text-dgray'>107 Reviews</div>
                  <div className='xs-title text-uppercase'>
                    <img className="me-1" src={getImages('star-on.png')} />
                    <img className="me-1" src={getImages('star-on.png')} />
                    <img className="me-1" src={getImages('star-on.png')} />
                    <img className="me-1" src={getImages('star-on.png')} />
                    <img className="me-1" src={getImages('star-on.png')} />
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className='review-slider-block px-0 wow reveal fadeIn'>
            <Slider ref={sliderRef} {...settings} className='review-slider'>
              {reviewsList.map((review, index) => (
                <div className="review-item py-0" key={index}>
                  <div className="review-box">
                    <div className="d-flex align-items-start justify-content-between mb-3">
                      <div>
                        <div className="md-title text-gray mb-2">{review.name}</div>
                        <div className="xs-title font-14 text-orange fw-bold">{review.date}</div>
                      </div>
                      <div>
                        <div className="quote-icon mb-2">
                          <img src={getImages("shape.png")} alt="quote" />
                        </div>
                      </div>
                    </div>
                    <div className="review-mnh">
                      <ReviewPreview review={review}/>
                    </div>
                  </div>
                </div>
              ))}

            </Slider>
          </div>
        </div>
      </section>
    </>
  )
}

export default CustomerReviews